import AirDatepicker from 'air-datepicker'
import 'air-datepicker/air-datepicker.css'
import localeUk from 'air-datepicker/locale/uk';

new AirDatepicker('.datepicker', {
    locale: localeUk
});
